import React, { useEffect, useState } from "react";
import axios from "axios";
import { QRCodeSVG } from "qrcode.react";
import {
  BsDownload,
  BsClipboard,
  BsCheck2,
  BsGooglePlay,
  BsAndroid2,
} from "react-icons/bs";
import Sidebar from "../Sidebar";
import Header from "../Header";
import API_BASE_URL from "../../config";
import "./MobileApp.css";

const humanFileSize = (size) => {
  if (!size || Number.isNaN(Number(size))) return null;
  const units = ["B", "KB", "MB", "GB"];
  const bytes = Number(size);
  const unit = Math.floor(Math.log(bytes) / Math.log(1024));
  const scaled = bytes / Math.pow(1024, unit);
  return `${scaled.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`;
};

export default function MobileApp() {
  const [latestRelease, setLatestRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("userToken");
        if (!token) { window.location.href = "/login"; return; }
        const headers = { Authorization: `Bearer ${token}` };
        const res = await axios.get(`${API_BASE_URL}/dashboard/mobile-app`, { headers });
        setLatestRelease(res.data?.latestRelease || null);
      } catch (err) {
        console.error("Failed to load mobile app data", err.response?.data || err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const copyLink = () => {
    if (!latestRelease?.download_url) return;
    navigator.clipboard.writeText(latestRelease.download_url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const size = humanFileSize(latestRelease?.file_size);

  return (
    <div className="page-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="container mt-4">
          <div className="page-header dash-head">
            <div>
              <h4>Mobile app</h4>
              <p className="page-subtitle">Install the Pairfon Android app and pair it to your account.</p>
            </div>
          </div>

          {loading ? (
            <div className="page-loading"><div className="spinner" /><p>Loading…</p></div>
          ) : (
            <div className="ma-grid2">
              {/* Get the app */}
              <div className="ma-card">
                <div className="ma-card-h"><h6>Get the app</h6></div>
                <div className="ma-get">
                  <div className="ma-qr">
                    {latestRelease?.download_url
                      ? <QRCodeSVG value={latestRelease.download_url} size={148} bgColor="#ffffff" fgColor="#0a0c12" />
                      : <span className="ma-qr-ph"><BsAndroid2 /></span>}
                  </div>
                  <div className="ma-get-side">
                    <p className="ma-desc">Scan to download the latest build, or use the direct link below.</p>
                    {latestRelease?.download_url ? (
                      <>
                        <div className="ma-ver">
                          <span className="ma-ver-tag">v{latestRelease.version_name}</span>
                          {size && <span className="ma-ver-sub">{size}</span>}
                        </div>
                        <div className="ma-btns">
                          <a href={latestRelease.download_url} target="_blank" rel="noopener noreferrer" className="ma-dl">
                            <BsDownload /> Download APK
                          </a>
                          <button className="ma-copy" onClick={copyLink} title="Copy download link">
                            {copied ? <BsCheck2 /> : <BsClipboard />} {copied ? "Copied" : "Copy link"}
                          </button>
                        </div>
                        <span className="ma-play"><BsGooglePlay /> Google Play — coming soon</span>
                      </>
                    ) : (
                      <p className="ma-none">No build published yet — check back shortly.</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Set it up */}
              <div className="ma-card">
                <div className="ma-card-h"><h6>Set it up</h6></div>
                <div className="ma-steps">
                  <div className="ma-step"><span className="n">1</span><div>Install &amp; open <b>Pairfon</b>.</div></div>
                  <div className="ma-step"><span className="n">2</span><div>Set Pairfon as your <b>default SMS app</b> when prompted.</div></div>
                  <div className="ma-step"><span className="n">3</span><div>Tap <b>Scan to pair</b> and scan the code on the <b>Android</b> page.</div></div>
                  <div className="ma-step"><span className="n">4</span><div>Send a test text — you’re live.</div></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
